import Home from '@/components/home';
import NotFound from '@/components/error-pages/notFound';
import AccessDenied from '@/components/error-pages/accessDenied';

const routes = [
    {
        path: '/',
        name: 'home',
        component: Home,
        meta: {
            breadcrumb: [
                { text: 'Home' }
			],
			requiresAuth: true
        }
    },
    {
        path: '*',
        name: 'notFound',
        component: NotFound,
        meta: {
            breadcrumb: [
                {
                    text: 'Home',
                    to: { name: 'home' }
                },               
                { text: 'Not found' }
            ]
        }
	},
	{
        path: '/accessDenied',
        name: 'accessDenied',
        component: AccessDenied,
        meta: {
            breadcrumb: [
                {
                    text: 'Home',
                    to: { name: 'home' }
                },               
                { text: 'Access denied' }
            ]
        }
    }
];

export default routes;


// WEBPACK FOOTER //
// ./src/components/routes/index.js